// Money screens print cents. lib/format.js formatCurrency rounds to whole
// dollars for the rail tiles, which is wrong for a figure someone is about to
// type into a bank transfer to the cent.
export function fmtCents(n) {
  if (n === null || n === undefined || n === '' || Number.isNaN(Number(n))) return 'not stated';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(n));
}

export function fmtPct(fraction) {
  if (fraction === null || fraction === undefined) return 'not stated';
  return `${(Number(fraction) * 100).toFixed(2).replace(/\.?0+$/, '')}%`;
}

// The Eastern calendar day, for a date input's starting value. "Today" is not
// a fact from a document, so offering it is not populating (V4).
export function todayEasternYmd() {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
}
